import {del, post, put} from "../util/http.service";

export const createTransactionRule = rule => post("/transaction-rules", rule);

export const updateTransactionRule = (id, rule) => put("/transaction-rules/" + id, rule);

export const deleteTransactionRule = id => del("/transaction-rules/" + id);

export const updatePositions = ids => put("/transaction-rules/positions", {ids});
